import type { StreamEntrypointsListRow } from "@/admin/entities/streamEntrypoints";
import type { StreamEntrypointsListQueryQueryType } from "@/types/graphql/admin.generated";

export function getTableData(data: unknown): {
  nodes: StreamEntrypointsListRow[];
  count: number;
} {
  const list = (data as StreamEntrypointsListQueryQueryType)?.streamEntrypoints;
  if (!list || !list.nodes) {
    return { nodes: [], count: 0 };
  }
  return list;
}

export function mapColumns(entrypoint: StreamEntrypointsListRow) {
  return [
    entrypoint.id,
    entrypoint,
    entrypoint.platform,
    entrypoint.stream,
    entrypoint.liveConnected,
    entrypoint.pull,
    entrypoint.createdAt,
  ];
}
